const defaultTalentBffUrl = '/api'
const defaultAuthApiUrl = '/auth-api'

export const env = {
  talentBffUrl: import.meta.env.VITE_TALENT_BFF_URL || defaultTalentBffUrl,
  authApiUrl: import.meta.env.VITE_AUTH_API_URL || defaultAuthApiUrl,
  /** Legacy App.tsx floating WhatsApp support button (wa.link). Empty string hides it. */
  supportWhatsAppUrl: import.meta.env.VITE_SUPPORT_WHATSAPP_URL ?? 'https://wa.link/exx389',
} as const
